<template lang="pug">
tr(
  data-test="cbr-acc-row"
).res-row
  td.table-username.text-center {{ item.username }}
  td(
    :class="{'red--text': item.max_reserved_students <= item.currently_reserved_students}"
  ).table-limit.text-center {{ item.currently_reserved_students }} / {{ item.max_reserved_students }}
  td.table-free.text-center {{ item.freeSlots }}
  td(
    v-for="date in dates" :key="date"
  ).date
    template(v-if="item.changes[date]") {{ item.changes[date].count }} (+{{ item.changes[date].change }})
    template(v-else) -
  
</template>

<script>
import {CBR_ACC_SLOTS_LOADING_STATUS, CBR_ACC_SLOTS_LOADING_STATUS_COLOR} from "../core/cbrAcc-const"
export default {
  props: {
    item: {
      required: true,
      type: Object
    },
    select: Function,
    isSelected: Boolean,
    cities: Array,
    dates: Array
  },
  data: () => ({
  }),

  mounted() {
  
  },
  filters: {

  },

  methods: {
    openLocationChoose() {
      this.$refs.courseLocationModal.toggle()
    },

    hideLocationChoose(isShowing) {
      if(isShowing) return
      this.$refs.courseLocationModal.toggle()

    }
  },
  
  components: {
    cbrAccImport: () => import('./CbrAccImport.vue'),
    courseLocationProvider: () => import('./CbrAccCourseLocationProvider.vue'),
    courseLocationModal: () => import('./cbrAccLocationChoose.vue'),
    checked: () => import('@/components/global/CheckBoolean.vue')
  },
}
</script>

<style lang="scss" scoped>
.date {
  width: 90px;
  text-align: center;
}

.table {
  &-username {
    width: 150px;
  }
  &-limit {
    width: 90px;
  }
  &-free {
    width: 90px;
  }
}

</style>

<style lang="scss">
.highlight-enter-active, .highlight-leave-active {
  transition: background 1s ease;
}

.highlight-leave-active {
  display: none;
}
.highlight-enter, .highlight-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  background: #78dfa6;
}

.highlight-leave-to {
  display: none;
}

.check {
  text-align: center;
  width: 100px;
}

</style>